import React, { FC } from "react";
import { Trans, useTranslation } from "next-i18next";
import styles from "./CSO2021Hero.module.scss";
import HeaderImg from "@cs/public/img/olympiad/cso21_photos/cso_winners.jpg";
import HeaderImgSmallMobile from "@cs/public/img/olympiad/cso21_photos/cso_winner_small_mobile.jpg";
import HeaderImgMobile      from "@cs/public/img/olympiad/cso21_photos/cso_winner_mobile.jpg";
import BasicHero from "../../hero/BasicHero";
import { NextSeo } from "next-seo";
import { useDeviceSize } from "@climate-science/component-library";

const CSO2021Hero: FC = () => {
  const { t } = useTranslation(["olympiad", "_links"]);
  const {isSmallMobile, isMobile} = useDeviceSize()

  const background = {
    src: HeaderImg,
    alt: "Planet Earthly"
  }
  
  if (isMobile) {
    background.src = HeaderImgMobile
  }

  if (isSmallMobile) {
    background.src = HeaderImgSmallMobile
  }

  return (
    <>
      <NextSeo title={ t("cso21.winners-title") }/>
      <BasicHero
        background={background}
        footer="cso21.hero-footer"
        heading="cso21.hero-header"
        ns="olympiad"
      >
        <p className={styles.p}>
          <Trans
            i18nKey={"cso21.hero-content"}
            t={t}
          />
        </p>
      </BasicHero>
    </>
  );
};

export default CSO2021Hero;
